import React, { PureComponent } from 'react';
import colors from 'constants/colors';
import MenuHoi from 'components/MenuHoi';
import ArrowDownIcon from 'components/SvgIcons/ArrowDown';

import { getButton } from './buttonMultiplexor';

class ButtonDropdown extends PureComponent {
    state = {};

    render() {
        let { type = 'primary-big', classes = [], children, options, ...props } = this.props;

        const SelectedButton = getButton(type);

        return (
            <MenuHoi items={options}>
                <SelectedButton
                    type={type}
                    classes={[...classes, 'fm-button__dropdown']}
                    {...props}
                >
                    {children}
                    <div className="fm-button__arrow-dropdown">
                        <ArrowDownIcon color={colors.primary.white} />
                    </div>
                </SelectedButton>
            </MenuHoi>
        );
    }
}

export default ButtonDropdown;
